export class SubsriptionsManager {
    constructor() {
        this.subscriptions = [];
    }
    subscribe(subscribible, sub) {
        this.subscriptions.push(subscribible.subscribe(sub));
    }
    unsubscribe() {
        for (const unsub of this.subscriptions) {
            unsub();
        }
        this.subscriptions = [];
    }
}
